import React from 'react';
export default function Loader(_ref) {
  var fullPage = _ref.fullPage,
    absolute = _ref.absolute,
    size = _ref.size,
    position = _ref.position;
  return /*#__PURE__*/React.createElement("div", {
    className: "loader-wrapper ".concat(position || '', " ").concat(absolute ? 'absolute' : '', " ").concat(fullPage ? 'full-page' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader ".concat(size || 'medium')
  }));
}